import { createUseStyles } from 'react-jss';

import { colors } from 'resources/styles/colors';

const useStyles = createUseStyles({
  socialsLogin: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    '& .viboButton': {
      '&.primaryDisplay': {
        color: colors.white,
      },

      '& .prefixIcon': {
        width: 'fit-content',
      },

      '&:not(:last-child)': {
        margin: '0 0 8px 0',
      },
    },
  },
});

export default useStyles;
